import { STEPS_WITH_TAGGING } from '../config'
import type { AuditTrailStep } from '../model'

export function getStepLabel(step: AuditTrailStep) {
  return STEPS_WITH_TAGGING.find((s) => s.value === step)?.label ?? ''
}
